import React, { useEffect, useState } from 'react';
import B2BDialog from '../../b2b-common/B2BDialog';
import { BookmarkAdd } from '@mui/icons-material';
import { generateTextField } from '../../b2b-common/helpers';

const LocaleNewDialog = ({ onAddingNewLocale }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [newLocale, setNewLocale] = useState("");

    useEffect(() => {
        openDialog();
    }, []);

    const openDialog = () => setShowDialog(true);
    const closeDialog = () => setShowDialog(false);

    const handleAddingNewLocale = () => {
        onAddingNewLocale(newLocale);
        closeDialog();
    }

    return (
        <B2BDialog title='New Locale' open={showDialog} onClose={() => closeDialog()}
            buttons={
                [
                    {
                        label: 'Add',
                        onClick: handleAddingNewLocale,
                        icon: <BookmarkAdd />
                    },
                ]}
        >
            {generateTextField("New Locale Code", newLocale, "label-key-ro-textfield", false, (e) => setNewLocale(e.target.value))}
        </B2BDialog >
    )
}

export default LocaleNewDialog;
